import * as PropTypes from 'prop-types'
import classNames from 'classnames'

export const HeadingsPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
  isLight: PropTypes.bool,
  level: PropTypes.oneOf([1, 2, 3, 4, 5, 6])
}

class Heading extends React.PureComponent {
  render () {
    const {
      children,
      className,
      id,
      isLight,
      level,
      size,
      ...restProps
    } = this.props

    const Tag = `h${level}`

    return (
      <Tag
        className={classNames('Heading', size,
          {
            [className]: className,
            'Heading--light': isLight
          }
        )}
        id={id}
        {...restProps}
      >
        {children}
      </Tag>
    )
  }
}

export class HeadingSection extends React.PureComponent {
  static propTypes = HeadingsPropTypes

  render () {
    return <Heading level={2} {...this.props} size='Heading--section' />
  }
}

export class HeadingHeader extends React.PureComponent {
  static propTypes = HeadingsPropTypes

  render () {
    return <Heading level={3} {...this.props} size='Heading--header' />
  }
}

export class HeadingSubHeader extends React.PureComponent {
  static propTypes = HeadingsPropTypes

  render () {
    return <Heading level={4} {...this.props} size='Heading--subHeader' />
  }
}


